import React from 'react';
import { Text, Box } from 'roo-ui/components';

export const AcknowledgementOfCountry = () => (
  <Box mb={8} data-testid="acknowledgement-text">
    <Text display="block" color="white">
      We acknowledge the Aboriginal and Torres Strait Islander Traditional
      Custodians of the land on which we work, live and fly.
    </Text>
    <Text display="block" color="white">
      We pay respect to Elders past, present and emerging.
    </Text>
  </Box>
);
